import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './user-permissions-config';
import { Observable } from 'rxjs';
import { API_PATH } from 'src/environments/environment';

@Injectable()
export class UserPermissionService extends AbstractCrudService {
  override title = 'Permissão de Grupo de Usuários';
  override pluralTitle = 'Permissões de Grupo de Usuários';

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public changeActives(objects: Object[]): Observable<void> {
    return this.httpClient.put<void>(
      `${API_PATH}${this.relativeUrl}/changeActives`,
      objects
    );
  }
}
